import {NavLink} from 'react-router-dom';
import {Tag} from 'antd';
import moment from 'moment';
import {AppRoutePaths} from 'routing/Routes';
import {ReservationDto} from '../../../../../../PRMGApiClient';

export const CalendarCell: React.FC<{date: Date; items: ReservationDto[]; type: 'day' | 'month'}> = ({
  date,
  items,
  type,
}) => {
  const currentDate = moment(date.toISOString());
  const listData = [];

  for (const item of items) {
    const startDate = moment(item.begins?.toISOString());
    const endDate = moment(item.ends?.toISOString());

    if (currentDate.isBetween(startDate, endDate, null, '[]') || currentDate.isSame(moment(item.begins), type)) {
      listData.push(item);
    }
  }
  return (
    <ul>
      {listData.map((item) => (
        <li key={item.id}>
          <NavLink to={AppRoutePaths.reservations.url + '/' + item.id}>
            <Tag color="orange" className="w-full flex justify-center hoverable">
              {item.car?.plateNumber}
            </Tag>
          </NavLink>
        </li>
      ))}
    </ul>
  );
};
